export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }
  var p={
    action:$params.action,
    taskId:$params.taskId,
    appId:$params.appId,
    formId:$params.formId,
    entityId:$params.entityId,
    activity:$params.activity,
    comment:$params.comment
  }
  if($params.extParams && $params.extParams.fullAuthType){
    p.fullAuthType = $params.extParams.fullAuthType;
  }
  PF.show("flowPlanned", p, function(res){
     $params.refreshComment(res);
    $form.fireEvent("afterflowproposed",res);
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-planned.js